import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getDiscordAuthUrl, isAuthenticated } from '@/api/auth';
import { Button } from '@/components/ui/button';

export default function Login() {
  const navigate = useNavigate();

  const handleDiscordLogin = () => {
    window.location.href = getDiscordAuthUrl();
  };

  React.useEffect(() => {
    if (isAuthenticated()) {
      navigate('/Home');
    }
  }, [navigate]);

  const discordIcon = (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.317 4.369a19.791 19.791 0 0 0-4.885-1.515.07.07 0 0 0-.075.037 13.81 13.81 0 0 0-.617 1.269 18.376 18.376 0 0 0-5.608 0A12.738 12.738 0 0 0 9.1 3.07a.065.065 0 0 0-.076-.037 19.736 19.736 0 0 0-4.886 1.515.062.062 0 0 0-.03.021C.533 9.045-.319 13.57.098 18.057a.082.082 0 0 0 .03.056 19.9 19.9 0 0 0 4.776 2.418.066.066 0 0 0 .072-.025c.37-.493.7-1.01 1.01-1.556a.064.064 0 0 0-.036-.09 13.054 13.054 0 0 1-1.855-.88.063.063 0 0 1-.006-.105c.125-.094.25-.193.37-.297a.06.06 0 0 1 .063-.01c3.905 1.8 8.094 1.8 12 .016a.056.056 0 0 1 .065.009c.12.105.246.203.373.298a.063.063 0 0 1-.006.105 12.87 12.87 0 0 1-1.855.879.064.064 0 0 0-.036.09 15.02 15.02 0 0 1 1.01 1.557.066.066 0 0 0 .071.025 19.9 19.9 0 0 0 4.777-2.419.068.068 0 0 0 .03-.057c.5-5.177-.947-9.633-3.548-13.667a.05.05 0 0 0-.03-.022zM8.02 15.331c-1.183 0-2.1-1.085-2.1-2.419 0-1.333.95-2.419 2.1-2.419 1.157 0 2.1 1.086 2.1 2.42 0 1.333-.946 2.418-2.1 2.418zm7.974 0c-1.183 0-2.1-1.085-2.1-2.419 0-1.333.95-2.419 2.1-2.419 1.157 0 2.1 1.086 2.1 2.42 0 1.333-.943 2.418-2.1 2.418z" fill="#ffffff"/>
    </svg>
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf6f1] via-[#f5ede3] to-[#efe5d8] text-[#2d1810] flex items-center justify-center">
      <div className="max-w-lg w-full p-8 bg-white/80 backdrop-blur-md border border-zinc-200 rounded-2xl shadow-xl">
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-4xl font-bold text-[#2d1810]">イラストアカデミア</h1>
          <p className="text-sm md:text-base text-[#6b5540] mt-2">Discordでシームレスにログインして、学習をすぐに始めましょう。</p>
        </div>

        <div className="space-y-4">
          <Button onClick={handleDiscordLogin} className="w-full justify-center bg-[#5865F2] hover:bg-[#4752c4] text-white border-transparent" type="button">
            <span className="mr-2">{discordIcon}</span>
            Discordでログイン
          </Button>
        </div>

        <p className="mt-6 text-xs text-[#7a6a56] text-center">
          Discord OAuth 2.0 を利用して認証しています。初回は Discord の許可画面にリダイレクトされます。
        </p>
      </div>
    </div>
  );
}
